/**
 * @graphql experimental
 */
import { differenceInDays } from 'date-fns';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data';
import { AIFC_ONBOARDING_STATE_KEYS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';
import {
	deserializeState,
	useGetOnboardingState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';

export const useShouldShowAIFirstCreateSideNav = () => {
	const { isRovoLLMEnabled } = useSessionData();
	const { data } = useGetOnboardingState(
		[
			AIFC_ONBOARDING_STATE_KEYS.hasDismissedAIFirstCreateSideNav,
			AIFC_ONBOARDING_STATE_KEYS.firstSeenAIFirstCreateSideNavAt,
		],
		!fg('aifc_onboarding_killswitch_2') || !fg('aifc_create_enabled'),
	);

	const { hasDismissedAIFirstCreateSideNav, firstSeenAIFirstCreateSideNavAt } =
		deserializeState(data);

	const isOnboardingPeriod = firstSeenAIFirstCreateSideNavAt
		? differenceInDays(new Date(), new Date(firstSeenAIFirstCreateSideNavAt)) < 14
		: false;

	return {
		shouldShowAIFirstCreateSideNav:
			isRovoLLMEnabled && !hasDismissedAIFirstCreateSideNav && isOnboardingPeriod,
		hasUserSeenAIFirstCreateSideNav: Boolean(firstSeenAIFirstCreateSideNavAt),
	};
};
